/**
 * Difficulty-gradient math (Brief §9 point 4 / CP21 "What to build" #4):
 * "trees further from the city take more hits to chop / plots more taps to
 * plant" (Grasschopper-style gradient - feel reference only, §9), plus the
 * "trees sense your heart rate" lore hook - over-MAF-ceiling HR increases
 * hits-per-tree. Pure, no Phaser import, so it's unit-testable without a
 * browser/canvas.
 *
 * All constants here are explicitly tunable "feel" values, not locked
 * design decisions - same caveat the Brief applies to its own streak-math
 * placeholders (§3.8). Route to Iris/Ruben once real playtesting exists.
 */
import { GAME_TUNING } from '../theme';

/**
 * @param distancePos 1-based tile distance from Minas Tirith (world position 0).
 * @param hrOverCeiling true when the harness/contract signals the player's
 *   average HR is over the MAF ceiling for this session.
 */
export function getHitsRequired(distancePos: number, hrOverCeiling: boolean): number {
  if (!Number.isInteger(distancePos) || distancePos < 1) {
    throw new Error(`getHitsRequired: distancePos must be a positive integer, got ${distancePos}`);
  }
  const gradientHits =
    GAME_TUNING.baseHits +
    Math.floor((distancePos - 1) / GAME_TUNING.distanceStepTiles) * GAME_TUNING.hitsPerDistanceStep;
  return hrOverCeiling ? gradientHits + GAME_TUNING.hrOverCeilingBonusHits : gradientHits;
}
